import Vue from 'vue';
import VuePrism from 'vue-prism';
Vue.use(VuePrism);
import '@/assets/prism/prism-synthwave84.css';
